import React from 'react';
import { useContext } from 'react';
import { AcordoContext } from 'contexts/lancamentos/AcordoState';
import LancamentoCard from '../LancamentoCard';
import LancamentoList from '../LancamentoList';

const LancamentosCriados = () => {
  const { lancamentosCriados } = useContext(AcordoContext);

  return (
    <LancamentoList>
      {lancamentosCriados.map((lancamento) => (
        <LancamentoCard key={lancamento.id} lancamento={lancamento} />
      ))}
    </LancamentoList>
  );
};

export default LancamentosCriados;
